import { queryInvoiceSubjectAndTax, querySettlements, queryTaskPage, queryUnApplyedInvoiceList } from '@core/main';
import { queryMyServerProducts } from '@core/main/api/crowd-source/my-product';
import { ESettlementStatus, ISettlementListParam, IUnApplyedInvoiceListParam } from '@core/main/types';

const defaultErrorMsg = '无此功能权限，请联系管理员进行授权！';

const checkProductPermission = async (productType: 0 | 1 = 0) => {
  let hasPermission = false;

  try {
    const items = await queryMyServerProducts(true, productType);

    hasPermission = items.length > 0;
  } catch (error) {
    console.error(error);
  }

  return hasPermission;
};

const dispatchPermission = async (dutyType: 0 | 1 = 0) => {
  let hasPermission = false;

  try {
    const { total } = await queryTaskPage({
      page: 1,
      size: 12,
      status: 2,
      dutyType,
    });

    hasPermission = total > 0;
  } catch (error) {
    console.error(error);
  }

  return hasPermission;
};

const payPermission = async (module: 'zhongbao' | 'cuohe' = 'zhongbao') => {
  let hasPermission = false;

  try {
    const { total } = await querySettlements({
      params: {
        page: 1,
        size: 12,
        orderStatus: ESettlementStatus.UNPAID,
      } as ISettlementListParam,
      module,
      term: 'company',
    });

    hasPermission = total > 0;
  } catch (error) {
    console.error(error);
  }

  return hasPermission;
};

const invoicePermission = async (dutyType: 0 | 1 = 0) => {
  let hasPermission = false;

  try {
    const { total } = await queryUnApplyedInvoiceList({
      page: 1,
      size: 12,
      dutyType,
    } as IUnApplyedInvoiceListParam, 'company');

    hasPermission = total > 0;
  } catch (error) {
    console.error(error);
  }

  return hasPermission;
};

export const crowdEntries: IGuideEntry[] = [
  {
    id: 'product',
    title: '众包灵工',
    name: '服务主体',
    buttons: [
      {
        name: '去查看',
        id: 'MyProduct',
        dataCheck: checkProductPermission,
        errorMsg: defaultErrorMsg,
        dataErrorMsg: '企业暂未配置产品，请联系客服人员进行产品授权！',
      },
    ],
  },
  {
    id: 'task',
    name: '任务创建',
    buttons: [
      {
        name: '去创建',
        id: 'TaskList',
        mode: 1,
        code: 'duty:list:add',
        dataCheck: checkProductPermission,
        errorMsg: defaultErrorMsg,
        dataErrorMsg: '企业暂未配置产品，请联系客服人员进行产品授权！',
      },
    ],
  },
  {
    id: 'dispatch',
    name: '派发任务',
    buttons: [
      {
        name: '去派发',
        id: 'TaskList',
        mode: 2,
        code: 'duty:list:distribute',
        errorMsg: defaultErrorMsg,
        dataErrorMsg: '目前不存在可派发的任务，可先创建有效任务，再进行任务派发操作！',
        dataCheck: dispatchPermission,
      },
    ],
  },
  {
    id: 'pay',
    name: '订单支付',
    buttons: [
      {
        name: '去支付',
        id: 'SettlementManagement',
        code: 'order:crowd:pay',
        errorMsg: defaultErrorMsg,
        dataErrorMsg: '目前不存在可支付的订单，可先创建有效订单，再进行订单支付操作！',
        dataCheck: payPermission,
      },
    ],
  },
  {
    id: 'invoice',
    name: '开票申请',
    buttons: [
      {
        name: '去开票',
        id: 'InvoiceManagement',
        code: 'invoice:apply',
        errorMsg: defaultErrorMsg,
        dataErrorMsg: '目前不存在可开票的订单，可在成功支付订单后，再进行开票申请操作！',
        dataCheck: invoicePermission,
      },
    ],
  },
];

export const matchEntries: IGuideEntry[] = [
  {
    id: 'product',
    title: '撮合灵工',
    name: '服务主体',
    buttons: [
      {
        name: '去查看',
        id: 'BrokerMyProduct',
        dataCheck: () => checkProductPermission(1),
        errorMsg: defaultErrorMsg,
        dataErrorMsg: '企业暂未配置产品，请联系客服人员进行产品授权！',
      },
    ],
  },
  {
    id: 'task',
    name: '任务创建',
    buttons: [
      {
        name: '去创建',
        id: 'BrokerLaborTaskList',
        mode: 1,
        code: 'match:duty:list:add',
        dataCheck: () => checkProductPermission(1),
        errorMsg: defaultErrorMsg,
        dataErrorMsg: '企业暂未配置产品，请联系客服人员进行产品授权！',
      },
    ],
  },
  {
    id: 'dispatch',
    name: '派发任务',
    buttons: [
      {
        name: '去派发',
        id: 'BrokerLaborTaskList',
        mode: 2,
        code: 'match:duty:list:distribute',
        errorMsg: defaultErrorMsg,
        dataErrorMsg: '目前不存在可派发的任务，可先创建有效任务，再进行任务派发操作！',
        dataCheck: () => dispatchPermission(1),
      },
    ],
  },
  {
    id: 'pay',
    name: '订单支付',
    buttons: [
      {
        name: '去支付',
        id: 'BrokerSettlements',
        code: 'order:match:pay',
        errorMsg: defaultErrorMsg,
        dataErrorMsg: '目前不存在可支付的订单，可先创建有效订单，再进行订单支付操作！',
        dataCheck: () => payPermission('cuohe'),
      },
    ],
  },
  {
    id: 'invoice',
    name: '开票申请',
    buttons: [
      {
        name: '服务费开票',
        id: 'BrokerInvoiceManagement',
        code: 'invoice:apply',
        errorMsg: defaultErrorMsg,
        dataErrorMsg: '目前不存在可开票的订单，可在成功支付订单后，再进行开票操作！',
        dataCheck: () => invoicePermission(1),
      },
      {
        name: '完税开票',
        id: 'BrokerPayTaxes',
        code: 'match:invoice:apply',
        errorMsg: defaultErrorMsg,
        dataErrorMsg: '目前不存在可开票的订单，可在成功支付订单后，再进行开票申请操作！',
        dataCheck: async () => {
          let hasPermission = false;

          try {
            const items = await queryInvoiceSubjectAndTax();

            hasPermission = items.length > 0;
          } catch (error) {
            console.error(error);
          }

          return hasPermission;
        },
      },
    ],
  },
];

export interface IGuideEntry {
  id: string;
  title?: string;
  name: string;
  buttons: Array<IGuideEntryButton>;
}

export interface IGuideEntryButton {
  /** 同时也是routeName */
  id: string;
  name: string;
  /** 按钮权限码 */
  code?: string;
  mode?: number;
  /** 错误提示 */
  errorMsg?: string;
  /** 数据权限错误提示 */
  dataErrorMsg?: string;
  /** 数据权限检查 */
  dataCheck?: () => Promise<boolean>;
}
